import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$subscriptionId/overview',
      params,
      replace: true,
    })
  },
})
